




















import Vue from 'vue'
export default Vue.extend({
    data() {
        return { 
            selectedOption: {
                name: '',
            },
            showDropdown: false,
        }
    },
    props: {
        options: {
            type: [Array, Object]
        },
        selected: {},
    },
    mounted() {
        this.selectedOption = this.selected;
    },
    methods: {
        updateOption(option) {
            this.selectedOption = option;
            setTimeout(() => {
                this.showDropdown = false;
            }, 100);
            this.$emit('updateOption', this.selectedOption);
        },

        toggleMenu() {
            this.showDropdown = !this.showDropdown;
        }
    }
})
